import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepComponentProps, IFlowStepProps } from '@folx-types/flow-steps';

import PharmacySelectionStep, {
	IPharmacySelectionStepPageContent,
} from './PharmacySelectionStep.component';

interface IPharmacySelectionStepPageProps extends IFlowStepProps {
	onPharmacySelection?: IFlowStepComponentProps['handleFormSubmission'];
	onCancel?: IFlowStepComponentProps['handleNavBack'];
}

const PharmacySelectionStepPage: FC<IPharmacySelectionStepPageProps> = ({
	path,
	stepKey,
	onPharmacySelection,
	onCancel,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "pharmacy-selection-step" }) {
				page_header
				pharmacy_name_text
				pharmacy_zip_text
				pharmacy_distance_text
				pharmacy_results_text
				show_additional_options_text
				hide_additional_options_text
				fetch_additional_results_text
				no_pharmacies_error
			}
		}
	`);

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const refinedContent: IPharmacySelectionStepPageContent = keysToCamel(
		pageContent
	) as IPharmacySelectionStepPageContent;

	return (
		<PharmacySelectionStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={onPharmacySelection ?? handleFormSubmission}
			handleNavBack={onCancel ?? handleNavBack}
		/>
	);
};

export default PharmacySelectionStepPage;
